// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__CfXj6","addWidgetButton":"Header_addWidgetButton__3ks6f","dashboardTabs":"Header_dashboardTabs__NmXPz","active":"Header_active__3czpC"};